import React from "react";

const Auth = ({ children }) => (
  <React.Fragment>
    <div className="h-100 w-100 login-bg">{children}</div>
  </React.Fragment>
);

export default Auth;
